import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { Call } from "../../common/game/GameControl";

const CallButton = ({ CurrentPlayer, gameHash, Sno, OnPlayerAction }) => {
  const gameState = useSelector((state) => state.gameState);
  const user = useSelector((state) => state.auth.user);

  const currentIndex = useMemo(
    () => gameState.ActivePlayers.findIndex((x) => x.PlayerId === user.Id),
    [gameState.ActivePlayers, user.Id]
  );

  const currentPlayer = useMemo(() => {
    if (currentIndex === -1) return {};
    return gameState.ActivePlayers[currentIndex];
  }, [currentIndex, gameState.ActivePlayers]);

  // DC-FE-CALLCHECK-TDD-GREEN-001: Compute betToPlayer for correct Check/Call semantics
  const betToPlayer = useMemo(() => {
    const currentRoundStatus = currentPlayer.CurrentRoundStatus || 0;
    return gameState.CurrentBet - currentRoundStatus;
  }, [gameState.CurrentBet, currentPlayer.CurrentRoundStatus]);

  const CallEventHandler = useCallback(
    (ev) => {
      // You can only call when betToPlayer is more than 0.
      if (betToPlayer === 0) {
        alert("Cannot call - nothing to call");
      } else {
        // DC-FE-REMOVE-LOCAL-DISPATCH-001: Call API only, state updated via SignalR "Call" event
        Call(user.Id, gameState.GameCode, currentIndex);
      }
    },
    [currentIndex, gameState, user, betToPlayer]
  );

  // DC-FE-CALLCHECK-TDD-GREEN-001: Render Call when betToPlayer > 0 (player owes chips)
  if (
    gameState.CurrentId === user.Id &&
    currentPlayer.PlayerCards?.length > 0 &&
    betToPlayer > 0
  )
    return (
      <button className="btn Call mt-1 me-1 me-md-0" onClick={CallEventHandler}>
        Call
      </button>
    );
  return <></>;
};

export default CallButton;
